import { useTranslation } from 'react-i18next'

const WHERE_KEYS = [
  'listing.imeiGuide.where.dial',
  'listing.imeiGuide.where.settings',
  'listing.imeiGuide.where.label',
  'listing.imeiGuide.where.box',
] as const

const PHOTO_KEYS = [
  'listing.imeiGuide.photo.flat',
  'listing.imeiGuide.photo.light',
  'listing.imeiGuide.photo.allDigits',
  'listing.imeiGuide.photo.noGlare',
] as const

export default function ImeiFindGuide() {
  const { t } = useTranslation()

  return (
    <details className="listing-tutorial ui-collapse-details" id="imei-find-guide">
      <summary className="listing-tutorial__summary">{t('listing.imeiGuide.summary')}</summary>
      <div className="ui-collapse-details__panel">
      <div className="ui-collapse-details__inner listing-tutorial__body">
        <p className="listing-tutorial__title">{t('listing.imeiGuide.title')}</p>
        <p className="meta-text listing-tutorial__intro">{t('listing.imeiGuide.intro')}</p>

        <p className="listing-tutorial__subtitle">{t('listing.imeiGuide.whereTitle')}</p>
        <ol className="listing-tutorial__steps">
          {WHERE_KEYS.map((key) => (
            <li key={key}>{t(key)}</li>
          ))}
        </ol>

        <p className="listing-tutorial__subtitle">{t('listing.imeiGuide.photoTitle')}</p>
        <p className="meta-text">{t('listing.imeiGuide.photoIntro')}</p>
        <ul className="listing-tutorial__bullets">
          {PHOTO_KEYS.map((key) => (
            <li key={key}>{t(key)}</li>
          ))}
        </ul>

        <p className="meta-text listing-tutorial__note">{t('listing.imeiGuide.note15')}</p>
      </div>
      </div>
    </details>
  )
}
